import React, {useEffect,useState, useRef} from 'react';
import Axios from "/plugins/axios";
// import ReactJWPlayer from 'react-jw-player';
import Head from 'next/head';
import TagManager from 'react-gtm-module';
import ClapprPlayer from '/components/Clappr/ClapprPlayer';
import PlaylistCarousel from '/components/VideoDetail/PlaylistCarousel';
import WidgetJwPlaylistPlayer from '/components/widgetJwPlaylistPlayer';

// import Slider from "react-slick";
const tagManagerArgs = {
    // gtmId: 'GTM-WCJSTPT',
    dataLayer: {
      userId: '001',
      userProject: 'project',
      event: '',
      CRMAuthor: 'CRMAuthor',
      Section: 'Section',
      articlePublishedDate: 'articlePublishedDate',
      utmCampaign: 'undefined',
      utmContent: 'undefined',
      utmMedium: 'undefined',
      utmSource: 'undefined',
      utmTerm: 'undefined'
  }
}

 const PlaylistWidget = (props) => {
    const [data, setData] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState('');
    const [showTitle, setShowTitle] = useState(false);
    const [currentTitle, setCurrentTitle] = useState('');
    const [currentSlug, setCurrentSlug] = useState('');
    const [currentPlayerId, setCurrentPlayerId] = useState('');
    const [sliderCurrent, setSliderCurrent] = useState();
    const slider = useRef();
    const targetOrigin = process.env.IS_LOCALHOST ? 'http://localhost' + (process.env.PORT ? ':'+process.env.PORT : '') : process.env.BACKEND_URL;

    useEffect(() => {
        let mounted = true;
        Axios.get(`/playlists/${props.url.query.id}`)
        .then(res => {
            if(mounted){
                let video = res.data.data;
                setLoaded(true);
                setData(res.data.data);
                setSliderCurrent(slider.current)
                window.parent.postMessage(res.data.data && res.data.data.length !== 0 ? 'isContent' : 'noContent', `${targetOrigin}`)
                if(window.self === window.top) {// I'm not in iframe
                    tagManagerArgs.dataLayer.CRMAuthor = video.author ? video.author.name : null
                    tagManagerArgs.dataLayer.Section = 'videos'
                    tagManagerArgs.dataLayer.articlePublishedDate = video.published_date.date
                    tagManagerArgs.dataLayer.utmCampaign = video.campaign ?  video.campaign.utm_campaign : null
                    tagManagerArgs.dataLayer.utmContent =  video.campaign ?  video.campaign.utm_content : null
                    tagManagerArgs.dataLayer.utmMedium =  video.campaign ?  video.campaign.utm_medium : null
                    tagManagerArgs.dataLayer.utmSource =  video.campaign ?  video.campaign.utm_source : null
                    tagManagerArgs.dataLayer.utmTerm =  video.campaign ?  video.campaign.utm_term : null
                    TagManager.dataLayer(tagManagerArgs)
                }
            }
        })
        .catch(err => {
            window.parent.postMessage('noContent', `${targetOrigin}`)
            setError(err.message);
            setLoaded(true);
        });

        return () => {
            mounted = false;
        };
    }, []);
    if (loaded) {
        if(error){
            return (
                <h3 style={{ textAlign: 'center' }}>{error}</h3>
            )
        }
        else if( data && data.length !== 0) {
            const queryId = props.url.query.videoId ? props.url.query.videoId : data.videos[0].slug;
            let videoIndex = data.videos && data.videos.length > 0 && data.videos.findIndex((item, index) => item.slug == queryId);
            const playlistPos = data.videos ? data.videos.findIndex((item, i)=> item.slug == queryId) + 1 : null;
            const urlVideoId = props.url.query.videoId ? props.url.query.videoId : null;
            const currentItem = urlVideoId ? data.videos[videoIndex] : data.videos[0];
            const envPlayer = process.env.WIDGET_PAGE_PLAYER && process.env.WIDGET_PAGE_PLAYER.toLowerCase();
            let poster = urlVideoId ? data.videos[videoIndex].posters.thumb : data.videos[0].posters.thumb;
            let video_url = urlVideoId ? data.videos[videoIndex].video_url : data.videos[0].video_url;
            let customProps = null;
            const jwPlayerId =  props.url && props.url.query.playerId ? props.url.query.playerId : currentItem.jwplayer_id;
            if(currentItem){
                customProps = {
                    ga: {
                        label: currentItem && currentItem.title ? currentItem.title : 'No Title'
                    }
                };
                if ( !currentItem.no_ads ) {
                    if ( currentItem.ad_tag ) // set custom AdTag
                        customProps.advertising = {
                            client: "googima",
                            tag: currentItem.ad_tag
                        };
                }
                else { //inject empty AdTag
                    customProps.advertising = {
                        tag: ''
                    };
                }
                customProps.floating = !currentItem.ad_tag;
            }

            return (
                <React.Fragment>
                <Head>
                    <link rel="stylesheet" type="text/css" charSet="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
                    <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
                    <link href="/static/css/widgetStyle.css" rel="stylesheet" />
                </Head>
                <div style={{ position: 'relative' }} id="clapprPlaylistWidget">
                    {data.videos && data.videos[videoIndex] &&
                    <>
                        {
                            envPlayer === 'jwplayer' ?
                            <WidgetJwPlaylistPlayer
                                poster={poster}
                                source={video_url}
                                upNext={data.videos[playlistPos]}
                                data={data}
                                slickGoToProp={sliderCurrent}
                                playlistPos={playlistPos}
                                currentItem={currentItem}
                                routeName="playlistWidget"
                                routeParams={{id: data.playlist_id, videoId: data.videos[playlistPos] ? data.videos[playlistPos].slug: ''}}
                                customProps={customProps}
                                jwPlayerId={jwPlayerId}
                            />
                            :
                            <ClapprPlayer
                                id="playlist-widget-clappr-player"
                                width="100%"
                                height="calc(100vw * 0.5625)"
                                autoPlay
                                poster={poster}
                                source={video_url}
                                video={currentItem}
                                upNext={data.videos[playlistPos]}
                                playlist={data}
                                slickGoToProp={sliderCurrent}
                                playlistPos={playlistPos}
                                routeName="playlistWidget"
                                routeParams={{id: data.playlist_id, videoId: data.videos[playlistPos] ? data.videos[playlistPos].slug: ''}}
                                isWidget
                            />
                    }
                        <PlaylistCarousel
                          playlistItems={data.videos}
                          queryId={queryId}
                          routeName={'playlistWidget'}
                          playlist={data}
                          slider={slider}
                          slickGoToProp={sliderCurrent}
                          currentItem={currentItem}
                          isPlaylist
                         />
                    </>
                    }
               </div>
               </React.Fragment>
            );
        }
        else{ return <h3>There is no video for this playlist.</h3> };
    } else {
        return (
            <div>
                Loading playlist widget...
                <div className="placeholderbox">
                  <div className="banner-holder"></div>
                  <hr className="hr-box" />
                  <span className="title-holder text-group"></span>
                  <div className="text-group p-holder"></div>
                  <div className="text-group"></div>
                </div>
            </div>
        );
    }
};
export default PlaylistWidget;
